import { render } from "./JournalDetail.vue?vue&type=template&id=109fb07d&scoped=true"
import script from "./JournalDetail.vue?vue&type=script&lang=js"
export * from "./JournalDetail.vue?vue&type=script&lang=js"

import "./JournalDetail.vue?vue&type=style&index=0&id=109fb07d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109fb07d"]])

export default __exports__